import { useSelector } from 'react-redux';
import { selectEffectivePersonId } from '../../store/auth/selectors';
import type { RootState } from '../../store/store';
import { useGetSelfFeatureFlagsQuery } from './api';

export interface CurrentFeatureFlagsState {
  flags: string[];
  globallyEnabledFlags: string[];
  identity: string | null;
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  isReady: boolean;
}

/**
 * Reads feature flags for the effective authenticated person.
 *
 * The person ID is used only as the RTK Query cache key. The API request is
 * still authorized by the active bearer token, so the server remains the
 * source of truth for flag evaluation.
 */
export function useCurrentFeatureFlags(): CurrentFeatureFlagsState {
  const identity = useSelector((state: RootState) => selectEffectivePersonId(state));
  const query = useGetSelfFeatureFlagsQuery(identity, { skip: !identity });

  return {
    flags: query.currentData?.flags ?? [],
    globallyEnabledFlags: query.currentData?.globally_enabled_flags ?? [],
    identity,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    isReady: Boolean(identity && query.currentData && query.isSuccess),
  };
}
